import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const Solution=()=> {
  const outcomes = [
    "More appointments booked, automatically",
    "More leads captured, even outside business hours",
    "Your team spends their time closing — not chasing leads"
  ];

  return (
    <section className="py-24 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Mockup side */}
          <motion.div 
            initial={{opacity: 0, x: -30}} 
            whileInView={{opacity: 1, x: 0}} 
            viewport={{once: true}} 
            className="relative"
          >
            <div className="absolute inset-0 bg-gold/20 blur-[100px] rounded-full"></div>
            <div className="relative bg-navy-lighter border border-white/10 rounded-2xl p-2 shadow-2xl overflow-hidden">
              <div className="w-full aspect-[4/5] bg-navy rounded-xl border border-white/5 overflow-hidden relative group">
                
                {/* Live GIF Content */}
                <img 
                  src="https://firebasestorage.googleapis.com/v0/b/phonesites-prod.appspot.com/o/images%2F6rHBijo2pUQV1ZlpCwFjbdqdjG53%2F1772040721791*Custom%20recording%202026-02-25%2011-25-34*gif?alt=media&token=a05f90a5-19d0-4746-9a07-32ae43b4534a" 
                  alt="Live Agent Demonstration"
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-500"
                />

                {/* Overlay UI */}
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-navy/20"></div>
                
                <div className="absolute bottom-6 left-6 right-6 z-10">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div>
                    <span className="text-xs font-bold tracking-widest text-white uppercase">Live Agent Active</span>
                  </div>
                  <h4 className="text-xl font-anton uppercase text-white">Direct Calendar Booking</h4>
                  <p className="text-gray-400 text-sm">Outcome-focused lead capture</p>
                </div>

                {/* Floating Icon */}
                <div className="absolute top-6 right-6 w-12 h-12 rounded-full bg-gold/90 backdrop-blur flex items-center justify-center shadow-lg border border-white/20">
                  <SafeIcon icon={FiIcons.FiUserCheck} className="text-2xl text-navy" />
                </div>
              </div>
            </div>
          </motion.div>

          {/* Text side */}
          <motion.div 
            initial={{opacity: 0, x: 30}} 
            whileInView={{opacity: 1, x: 0}} 
            viewport={{once: true}} 
          >
            <h2 className="text-4xl md:text-5xl font-anton uppercase tracking-wide text-white mb-8">
              MEET <span className="text-gold">AGENTONDEMAND</span>
            </h2>
            
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              AgentOnDemand puts a live agent on standby on your booking page, ready the instant a visitor arrives. No typing, no waiting, no guessing — just a real conversation that turns into a real appointment on your calendar.
            </p>
            
            <p className="text-lg font-bold text-white mb-10 border-l-4 border-gold pl-6 py-2 bg-white/5">
              The outcome, not the feature: you stop losing ready-to-buy visitors to a form or a bot, and you start seeing more booked appointments and more qualified leads land in your calendar.
            </p>

            <div className="space-y-6">
              {outcomes.map((bullet, idx) => (
                <div key={idx} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center mt-1 border border-gold/20">
                    <SafeIcon icon={FiIcons.FiCheck} className="text-gold" />
                  </div>
                  <p className="text-xl font-medium text-white">{bullet}</p>
                </div>
              ))}
            </div>
          </motion.div>
          
        </div>
      </div>
    </section>
  );
};

export default Solution;